import { render, staticRenderFns } from "./transferOutOrderAdd.vue?vue&type=template&id=37c85a18"
import script from "./transferOutOrderAdd.vue?vue&type=script&lang=js"
export * from "./transferOutOrderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports